export default "__VITE_PUBLIC_ASSET__a7feb12f__"